import i18n from '@/i18n'
import { jsPDF } from "jspdf";
import moment from "moment";

import { ARABIC_BOLD_FONT } from "../../utils/utils";
var pageWidth = 210;
var pageHeight = 297;

var start = 10;
var end = 200;

var normalFontSize = 16;
var mediumFontSize = 14;
var smallFontSize = 10;

var lineHeight = Math.floor(normalFontSize / 2);
var currentY = 2 * lineHeight - 10;

let doc = new jsPDF("p", "mm", [pageWidth, pageHeight]);

// tpl = { header:{}, general:{}, table:{}, total:{}, watermark:{}, bottomBanner:{} }
const printInvoice = (invoice, type, logoDataUrl, tpl, enableTax = false) => {
  tpl = tpl || {};
  const header = tpl.header || {};
  const general = tpl.general || {};
  const table = tpl.table || {};
  const total = tpl.total || {};
  const watermark = tpl.watermark || {};
  const bottom = tpl.bottomBanner || {};

  doc = new jsPDF("p", "mm", [pageWidth, pageHeight]);
  doc.addFileToVFS('Amiri-Bold.ttf', ARABIC_BOLD_FONT);
  doc.addFont('Amiri-Bold.ttf', 'Amiri', 'normal');

  // --- Watermark ---
  if (watermark.show && watermark.text) {
    doc.setTextColor(245, 245, 245);
    doc.setFontSize(48);
    fontType("bold");
    doc.text(String(watermark.text), pageWidth / 2, pageHeight / 2, { align: "center" });
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(normalFontSize);
  }

  // --- Header: Company info ---
  if (header.showBrand !== false) {
    doc.setFontSize(smallFontSize);
    const ci = invoice.companyInfo || {};
    let headerLines = [ci.name, ci.vat, ci.addressLine1, ci.addressLine2, ci.addressLine3].filter(Boolean);
    headerLines.forEach((item, index) => {
      doc.text(item, start, currentY + (lineHeight - 2) * index);
    });
  }

  // Logo
  try {
    const logoSrc = logoDataUrl || "img/logo.png";
    const fmt = logoDataUrl ? "PNG" : "jpeg";
    doc.addImage(logoSrc, fmt, 100, currentY - 7.8, 30, 30, undefined, "FAST");
  } catch (e) {
    // Logo not available
  }

  nextLine(3);
  seperator();
  nextLine(1);

  // --- Date ---
  doc.setFontSize(smallFontSize);
  if (header.showInvoiceDate !== false) {
    doc.text(`Date: ${moment().format('YYYY/MMMM/DD')} `, start, currentY);
  }
  fontType('normal');
  nextLine(2);

  // --- Invoice No ---
  if (header.showInvoiceNo !== false) {
    fontSize(normalFontSize);
    const invoiceLabel = enableTax ? i18n.t('accounts.taxInvoiceNo') : i18n.t('accounts.invoiceNo');
    const invoiceLabelAr = enableTax ? "\u0641\u0627\u062A\u0648\u0631\u0629 \u0636\u0631\u064A\u0628\u064A\u0629 \u0631\u0642\u0645" : "\u0641\u0627\u062A\u0648\u0631\u0629 \u0631\u0642\u0645";
    doc.text(`${invoiceLabel} : ${invoice.invoiceNo}`, start, currentY);
    setArabicFont();
    doc.text(` ${invoice.invoiceNo}:${invoiceLabelAr} `, end, currentY, {
      align: "right"
    });
    fontType("normal");
  }
  nextLine(1);

  // --- QR code ---
  if (header.showQr !== false && invoice.qrCode) {
    doc.addImage(invoice.qrCode, "png", start + 150, currentY, 30, 30);
  }
  nextLine(2);
  fontSize(mediumFontSize);

  // --- Order / Refund Summary ---
  if (header.showInvoiceDate !== false) {
    if (type === "invoice") {
      doc.text("Order Summery", start, currentY);
      nextLine(1);
      doc.text("Order placed at : ", start, currentY);
    }
    if (type === "refund") {
      doc.text("Refund Summery", start, currentY);
      nextLine(1);
      doc.text("Refund placed at : ", start, currentY);
    }

    moment.locale('en');
    doc.text(
      moment(new Date(parseInt(invoice.createdAt))).format("DD MMM YYYY, h:mm:ss A"),
      start + 40,
      currentY
    );
    nextLine(1);
  }

  if (type === "invoice") {
    doc.text(`Plan name: ${invoice.note || ''} `, start, currentY);
  }
  if (type === "refund") {
    doc.text(`Note: ${invoice.note || ''} `, start, currentY);
  }

  fontSize(mediumFontSize);
  nextLine(2);

  // --- Delivery / Refund to ---
  if (general.showBillTo !== false) {
    nextLine(1.5);
    if (type === "invoice") doc.text("Delivery to ", start, currentY);
    if (type === "refund") doc.text("Refund to", start, currentY);
    nextLine(1);
    const firstName = (invoice.customerInfo && invoice.customerInfo.firstnameEn) || "";
    const lastName = (invoice.customerInfo && invoice.customerInfo.lastnameEn) || "";
    const fullName = `${firstName} ${lastName}`.trim();
    const hasArabic = /[\u0600-\u06FF]/.test(fullName);
    if (hasArabic) {
      setArabicFont();
    } else {
      fontType("bold");
    }
    doc.text(fullName, start, currentY);
    nextLine(1);
    fontType("normal");

    if (general.showAddress !== false) {
      let addresses = getFullAddress(invoice);
      setArabicFont();
      addresses.forEach(address => {
        doc.text(address, start, currentY);
        nextLine(1);
      });
      fontType("normal");
    }
  }
  nextLine(1);

  // --- Table ---
  if (table.showLineItems !== false) {
    // Grey header bar
    doc.setFillColor(189, 189, 189);
    doc.rect(start, currentY, end - start, 10, "F");
    nextLine(0.7);
    doc.setTextColor(255, 255, 255);
    setArabicFont();
    doc.setFontSize(smallFontSize);

    doc.text("Item Name /\u0648\u0635\u0641 \u0627\u0644\u0645\u0646\u062A\u062C", start + 5, currentY);
    if (table.showQuantity !== false) {
      doc.text("Quantity / \u0627\u0644\u0643\u0645\u064A\u0629", start + 45, currentY);
    }
    doc.text("Price / \u0627\u0644\u0633\u0639\u0631", start + 75, currentY);
    if (total.showTax !== false) {
      doc.text("Tax / \u0627\u0644\u0636\u0631\u064A\u0628\u0629", start + 100, currentY);
      doc.text("Tax Value / \u0642\u064A\u0645\u0629 \u0627\u0644\u0636\u0631\u064A\u0628\u0629 ", start + 125, currentY);
    }
    doc.text("Total  / \u0627\u0644\u0627\u062C\u0645\u0627\u0644\u064A", start + 165, currentY);
    nextLine(1.5);
    doc.setTextColor(0, 0, 0);
    fontType("normal");

    // Row
    doc.text(`${invoice.note || ''}`, start + 5, currentY);
    if (table.showQuantity !== false) {
      doc.text("1", start + 45, currentY);
    }
    doc.text(`${(invoice.amount || 0).toFixed(2)}`, start + 75, currentY);

    if (total.showTax !== false) {
      let percentage = 0;
      const baseForTax = (invoice.amount || 0) - (invoice.discount || 0);
      if (invoice.tax > 0 && baseForTax > 0) {
        percentage = invoice.tax / baseForTax * 100;
      }
      doc.text(String(percentage.toFixed(1)) + '%', start + 100, currentY);
      doc.text(`${(invoice.tax || 0).toFixed(2)}`, start + 125, currentY);
    }
    doc.text(`${(invoice.total || 0).toFixed(2)}`, start + 165, currentY);
    nextLine(1);
    seperator();
    nextLine(1);
  }

  // --- Totals ---
  if (total.showSubtotal !== false) {
    setArabicFont();
    doc.text("Total / \u0627\u0644\u0645\u062C\u0645\u0648\u0639", end - 50, currentY, { align: "right" });
    fontType("normal");
    doc.text(`${(invoice.amount || 0).toFixed(2)}`, end - start, currentY, { align: "right" });
    nextLine(1.5);
  }

  if (type === "invoice" && total.showDiscount !== false) {
    setArabicFont();
    doc.text("Discount / \u0627\u0644\u062E\u0635\u0645", end - 50, currentY, { align: "right" });
    fontType("normal");
    doc.text(`${(invoice.discount || 0).toFixed(2)}`, end - start, currentY, { align: "right" });
    nextLine(1.5);
  }

  if (total.showTax !== false) {
    setArabicFont();
    doc.text("Tax Amount / \u0627\u0644\u0636\u0631\u064A\u0628\u0629", end - 50, currentY, { align: "right" });
    fontType("normal");
    doc.text(`${(invoice.tax || 0).toFixed(2)}`, end - start, currentY, { align: "right" });
    nextLine(1.5);
  }

  // --- Grand total grey bar ---
  if (total.showGrandTotal !== false) {
    doc.setFillColor(222, 222, 222);
    doc.rect(start, currentY, end - start, 10, "F");
    nextLine(0.7);
    fontType("bold");
    if (type === "invoice") {
      setArabicFont();
      doc.text("Total Invoice / \u0627\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629", end - 50, currentY, { align: "right" });
    }
    if (type === "refund") {
      doc.text("Refund Total: ", end - 50, currentY, { align: "right" });
    }
    fontType("normal");
    doc.text(`${(invoice.total || 0).toFixed(2)}`, end - start, currentY, { align: "right" });
  }

  // --- Bottom line ---
  fontType("bold");
  doc.line(0, pageHeight - 20, end, pageHeight - 20);
  fontType("normal");

  // --- Footer ---
  if (bottom.showFooterContact !== false) {
    const ci = invoice.companyInfo || {};
    let footParts = [ci.name, ci.vat, ci.addressLine1, ci.addressLine2].filter(Boolean);
    if (footParts.length) {
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text(footParts.join("  |  "), pageWidth / 2, pageHeight - 15, { align: "center" });
      doc.setTextColor(0, 0, 0);
    }
  }

  // Reset Y
  currentY = 2 * lineHeight - 10;

  if (type === "invoice") doc.save(`Invoice_${invoice.invoiceNo}.pdf`);
  if (type === "refund") doc.save(`Refund_${invoice.invoiceNo}.pdf`);
};

const fontType = type => {
  const style = type === "medium" ? "normal" : type;
  doc.setFont("helvetica", style);
};
const fontSize = size => doc.setFontSize(size);
const nextLine = numberOfLines => (currentY += numberOfLines * lineHeight + 1);
const setArabicFont = () => doc.setFont('Amiri', 'normal');

const seperator = () => {
  doc.setDrawColor(210, 210, 210);
  doc.line(start, currentY, end, currentY);
};

const getFullAddress = invoice => {
  const live = invoice.liveAddress;
  if (live) {
    const areaName = live.area && live.area.nameEn;
    const blockName = live.block && live.block.block;
    const line1Parts = [areaName && `Area: ${areaName}`, blockName && `Block: ${blockName}`].filter(Boolean);
    const line2Parts = [live.street, live.jedha, live.house_number, live.building_number].filter(Boolean);
    const lines = [];
    if (line1Parts.length) lines.push(line1Parts.join(", "));
    if (line2Parts.length) lines.push(line2Parts.join(", "));
    if (lines.length) return lines;
  }

  const info = invoice.customerInfo;
  if (!info) return [];
  if (info.addressLine1) {
    let fullAddress = info.addressLine1.split(",");
    if (fullAddress.length > 3) {
      let addressLine1 = fullAddress[0];
      let addressLine2 = fullAddress[2];
      fullAddress = [addressLine1, addressLine2];
    }
    return fullAddress;
  }
  if (info.addressLine2) {
    return info.addressLine2
      .split(",")
      .map(part => part.trim())
      .filter(part => part && part.toLowerCase() !== "null" && part.toLowerCase() !== "undefined");
  }
  return [];
};

export { printInvoice };
